import { addKsql, KuxFilteredCategoriesDTO, SpecialWidgetTypeEnum, UIDAPresentationTypeEnum } from '@kaltura-ott/tvpil';
import { container } from 'tsyringe';

import { convertKalturaAssetToTvpil } from '../../../../../rhino/data/compat';
import { queryClient } from '../../../../../rhino/data/queryClient';
import { fetchRailCollection } from '../../../../../rhino/phoenix/data';
import { featureEnabler } from '../../../../../utils';
import { DmsStore } from '../../../../dms';
import { CardPlaceholder, EntitiesType } from '../../../../entities';
import { TransactionStore } from '../../../../transaction/transaction-store';
import { getItemsInPage, DEFAULT_PAGE_SIZE } from '../rail-store-helper-v2';
import { RailStoreV2 } from '../rail-store-v2';

const HIDE_TITLE = 'hideTitleForLogoRail';

export class CollectionRailStoreV2 extends RailStoreV2<EntitiesType> {
  subtype = UIDAPresentationTypeEnum.collection;
  specialWidgetType?: SpecialWidgetTypeEnum;
  protected orderBy?: string;
  protected handleAssetListErrors: boolean;
  protected dmsStore: DmsStore;

  constructor(
    categoryTree: KuxFilteredCategoriesDTO,
    parentCategoryTree: KuxFilteredCategoriesDTO,
    children?: [],
    handleAssetListErrors?: boolean,
  ) {
    super(categoryTree, parentCategoryTree, children);
    this.dmsStore = container.resolve<DmsStore>('dmsStore');
    this.specialWidgetType = categoryTree.specialWidgetType;
    this.orderBy = categoryTree.searchProperty.sortingType || '';
    this.handleAssetListErrors = handleAssetListErrors || false;

    if (categoryTree.link.inAppLink?.toLowerCase() === HIDE_TITLE.toLowerCase()) {
      this.specialWidgetType = SpecialWidgetTypeEnum.logo;
    }
  }

  protected get transactionStore() {
    return container.resolve<TransactionStore>('transactionStore');
  }

  protected async getData(
    pageIndex: number,
    items: (EntitiesType | CardPlaceholder)[],
  ): Promise<{ items: (EntitiesType | CardPlaceholder)[]; totalCount: number; newItems: EntitiesType[] }> {
    const kSql =
      this.transactionStore.isAdultEntitled || !this.dmsStore.dms.adultsConfigurations?.categoryReferenceId
        ? this.aggregatedKSQL
        : addKsql(this.aggregatedKSQL, `in_app_link!='${this.dmsStore.dms.adultsConfigurations?.categoryReferenceId}'`);

    const data = await queryClient.fetchQuery({
      queryKey: ['COLLECTIONS', this.channels[0], pageIndex],
      queryFn: () =>
        fetchRailCollection({
          channelId: this.channels[0],
          groupBy: this.groupBy,
          kSql,
          orderBy: this.orderBy,
          pageSize: DEFAULT_PAGE_SIZE,
          pageIndex: pageIndex,
        }),
      staleTime: 0,
      gcTime: 0,
    });

    const newItems: EntitiesType[] = [];

    for (let i = 0; i < data.objects.length; i++) {
      const assetType = convertKalturaAssetToTvpil(data.objects[i], {
        ...(featureEnabler.variation('IS_NEW_COLLECTION_GRID', false)
          ? { presentationType: UIDAPresentationTypeEnum.collection }
          : undefined),
      });

      if (assetType) {
        newItems.push(assetType);
      }
    }

    this.innerItems.push(...newItems);
    return { items: this.items, totalCount: data.totalCount, newItems };
  }

  protected async getAdditionData(itemsInPage: EntitiesType[]): Promise<void> {
    return;
  }

  protected async restoreAdditionData(pageIndex: number, items: EntitiesType[]): Promise<void> {
    return this.getAdditionData(getItemsInPage(items, pageIndex));
  }
}
